import api from '@api';
import { call, put, takeEvery, select } from 'redux-saga/effects';
import {
    getBillsOfMaterialsListFetch as getBillsOfMaterialsListFetchAction,
    getBillsOfMaterialsListFetchSuccess,
    getBillsOfMaterialsListFetchFailure,
    activateBillOfMaterialsFetchSuccess,
    activateBillOfMaterialsFetchFailure,
    deactivateBillOfMaterialsFetchSuccess,
    deactivateBillOfMaterialsFetchFailure,
} from './reducer';
import { BillsOfMaterialsListResType } from 'src/types/billsOfMaterialsList';
import translate from '@translate';
import { RootStoreType } from 'src/types/store';

const getBillsOfMaterialsListFetchRequest = async (idProduct?: string) => {
    const res = await api(
        'get',
        `api/secure/bill-of-materials?withProducts=true${idProduct ? `&idProduct=${idProduct}` : ''}`
    );
    return res.data.data;
};

function* getBillsOfMaterialsListFetch(action: { type: string; payload?: string }) {
    try {
        const response: BillsOfMaterialsListResType = yield call((): any =>
            getBillsOfMaterialsListFetchRequest(action.payload)
        );
        yield put(getBillsOfMaterialsListFetchSuccess(response));
    } catch (error) {
        yield put(getBillsOfMaterialsListFetchFailure({ error }));
    }
}

export function* getBillsOfMaterialsListFetchWatch() {
    yield takeEvery('billsOfMaterialList/getBillsOfMaterialsListFetch', getBillsOfMaterialsListFetch);
}

const activateBillOfMaterialsFetchRequest = async (idBillOfMaterials: number) => {
    const res = await api('put', `api/secure/bill-of-materials/${idBillOfMaterials}/activate`);
    return res.data.data;
};

function* activateBillOfMaterialsFetch(action: { type: string; payload: number }) {
    try {
        const response: BillsOfMaterialsListResType = yield call((): any =>
            activateBillOfMaterialsFetchRequest(action.payload)
        );
        yield put(
            activateBillOfMaterialsFetchSuccess({
                ...response,
                messageSuccess: { title: translate('messages.billOfMaterialsActive') },
            })
        );

        const idProduct: string = yield select((state: RootStoreType) => state.billsOfMaterialList.idBillOfMaterials);
        yield put(getBillsOfMaterialsListFetchAction(idProduct));
    } catch (error) {
        yield put(activateBillOfMaterialsFetchFailure({ error }));
    }
}

export function* activateBillOfMaterialsFetchWatch() {
    yield takeEvery('billsOfMaterialList/activateBillOfMaterialsFetch', activateBillOfMaterialsFetch);
}

const deactivateBillOfMaterialsFetchRequest = async (idBillOfMaterials: number) => {
    const res = await api('put', `api/secure/bill-of-materials/${idBillOfMaterials}/deactivate`);
    return res.data.data;
};

function* deactivateBillOfMaterialsFetch(action: { type: string; payload: number }) {
    try {
        const response: BillsOfMaterialsListResType = yield call((): any =>
            deactivateBillOfMaterialsFetchRequest(action.payload)
        );
        yield put(
            deactivateBillOfMaterialsFetchSuccess({
                ...response,
                messageSuccess: { title: translate('messages.billOfMaterialsDeactive') },
            })
        );

        const idProduct: string = yield select((state: RootStoreType) => state.billsOfMaterialList.idBillOfMaterials);
        yield put(getBillsOfMaterialsListFetchAction(idProduct));
    } catch (error) {
        yield put(deactivateBillOfMaterialsFetchFailure({ error }));
    }
}

export function* deactivateBillOfMaterialsFetchWatch() {
    yield takeEvery('billsOfMaterialList/deactivateBillOfMaterialsFetch', deactivateBillOfMaterialsFetch);
}
